"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.testResults.title': 'Wyniki testów',
    'botTest.testResults.results': 'wyników',
    'botTest.testResults.result': 'Wynik',
    'botTest.testResults.metrics': 'Metryki',
    'botTest.testResults.totalMessages': 'Łączna liczba wiadomości',
    'botTest.testResults.totalTokens': 'Łączna liczba tokenów',
    'botTest.testResults.totalCost': 'Łączny koszt',
    'botTest.testResults.executionTime': 'Czas wykonania',
    'botTest.testResults.averageResponseTime': 'Średni czas realizacji pytania',
    'botTest.testResults.inputTokens': 'Tokeny wejściowe',
    'botTest.testResults.outputTokens': 'Tokeny wyjściowe',
    'botTest.testResults.messageCount': 'Wiadomości',
    'botTest.testResults.error': 'Błąd',
    'botTest.testResults.response': 'Odpowiedź AI',
    'botTest.testResults.questionGeneration': 'Generowanie pytań',
    'botTest.testResults.success': 'Sukces',
    'botTest.testResults.tokens': 'Tokeny',
    'botTest.testResults.cost': 'Koszt',
    'botTest.testResults.status.pending': 'Oczekujący',
    'botTest.testResults.status.running': 'W trakcie',
    'botTest.testResults.status.completed': 'Zakończony',
    'botTest.testResults.status.failed': 'Niepowodzenie',
    'botTest.testResults.questionsAndAnswers': 'Pytania i Odpowiedzi',
    'botTest.testResults.question': 'Pytanie',
    'botTest.testResults.questionLabel': 'P',
    'botTest.testResults.answerLabel': 'O',
    'botTest.testResults.answerStartTime': 'Czas odpowiedzi (pierwszy token)',
    'botTest.testResults.no_results': 'Brak dostępnych wyników testów',
    'botTest.testResults.no_results_description': 'Uruchom test, aby zobaczyć wyniki tutaj.',
};
